module.exports = __webpack_public_path__ + "img/btn_count.13f33e10.svg";